import { AppBar, Box, Button, ThemeProvider, useMediaQuery, useTheme } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { DesktopToolbar } from '../ui-components/components/Toolbar/Desktop';
import { ButtomMenuBar } from "../components/BottomBar";
import { ActivitiesBottomBar } from "../ui-components/Layouts/ActivitiesBottomBar"
import { BuyerModal } from "../ui-components/Layouts/BuyerModal";
import { MobileToolbar } from "../ui-components/components/Toolbar/Mobile";

import natheme from "../ui-components/theme";
import { FirebaseApp } from "firebase/app";
import { Auth, User, getAuth, onAuthStateChanged } from "firebase/auth";
import { LoginModal } from "../ui-components/components/LoginModal";
import { MenuItem } from "../ui-components/components/Toolbar";
import { useLocalStorage } from "../ui-components/hooks/useLocalStorage";
import axios from "axios";
import { MeMenu } from "../ui-components/components/Menu/MeMenu";
import { useRouter } from "next/router";
// import { AppointmentDialog, AppointmentProps } from "./Activities/Appointment";
// import { getImageUrl, getProjectImageUrl } from "../utils/utils";
import { useTranslation } from "react-i18next";
import { isDesktop } from "react-device-detect";
import { sendGAEvent, sendGTMEvent } from '@next/third-parties/google'

const loggedMenuItems = [
  {
    key: 'requirements',
    text: 'menu.myRequirement',
    link: '/requirements',
  },
  {
    key: 'interested',
    text: 'menu.interested',
    link: '/interested',
  },
  {
    key: 'recently',
    text: 'menu.recently',
    link: '/recently',
  },
  {
    key: 'appointment',
    text: 'menu.appointment',
    link: '/appointment',
  },
  {
    key: 'inquiry',
    text: 'menu.inquiry',
    link: '/inquiry',
  },
] as MenuItem[];

export interface AppBarState {
  user: User | null;
  userInfo: any | null;
}

export interface MainAppBarProps {
  logoPath: string;
  app: FirebaseApp;
  context: any | null;
  auth: Auth;

  onLanguageChanged?: (ln: string) => void;
  onMenuClicked?: (type: string) => void;
  onMobileSearchClicked?: () => void;
  onRequirementClicked?: (isOpen: boolean) => void;
}

export type LoginFor = 'appointment' | 'requirements' | 'interested' | 'recently' | null;

export const MainAppBar = (props: MainAppBarProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const router = useRouter();
  const { pathname, asPath, query } = router;

  const [isBuyerModalOpen, setIsBuyerModalOpen] = useState<boolean>(false);
  const [isLoginModalOpened, setIsLoginModalOpened] = useState<boolean>(false);
  const [loginModalMode, setLoginModalMode] = useState<'register'|'login'>('login');
  const [userInfo, setUserInfo] = useLocalStorage<any>(`9asset.userinfo`);
  const [isMeMenuOpened, setIsMeMenuOpened] = useState<boolean>(false);
  const [scrolled, setScrolled] = useState(false);

  // const [isReloadNeed, setIsReloadNeed] = useState<boolean>(false);
  const isReloadNeedRef = useRef(false);

  // const [appointmentDialog, setAppointmentDialog] = useState<boolean>(false);
  // const [appointmentState, setAppointmentState] = useState<AppointmentProps|null>(null);

  const [loginFor, setLoginFor] = useState<string|undefined>(undefined);
  const loginForRef = useRef(loginFor);
  const [path, setPath] = useState<string|null>(null);
  
  const [state, setState] = useState<AppBarState>({
    user: null,
    userInfo: userInfo
  });

  const { t } = useTranslation('common');

  useEffect(() => {
    const unsub = getToken();
    window.addEventListener('loginrequested', handleLoginRequested);
    return () => { 
      unsub && unsub();
      window.removeEventListener('loginrequested', handleLoginRequested);
    };
  }, []);

  const handleLoginRequested = (e: CustomEvent<{ reload?: boolean }>) => {
    loginRequested(e.detail?.reload || false);
  }

  useEffect(() => {
    console.log(props.context)
  }, [props.context])


  useEffect(() => {
    const handleScroll = () => {
      // เปลี่ยนเป็นสีขาวเมื่อเลื่อนลงมากกว่า 50px
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    
    // Cleanup function
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    console.log(loginFor)
    loginForRef.current = loginFor;
  }, [loginFor]);

  useEffect(() => {
    console.log(`User Info:`, userInfo);
    setState((prev) => ({ ...prev, ...state, userInfo: userInfo }));
  }, [userInfo]);

  useEffect(() => {
    console.log(props.auth);
    console.log(props.app);
  }, [props.auth]);

  useEffect(() => {
    setState((prev) => ({ ...prev, user: props.auth.currentUser }));
  }, [props.auth.currentUser])

  const getToken = () => {
    setState({ ...state, user: props.auth.currentUser });
    return onAuthStateChanged(props.auth || getAuth(props.app), async (user: User | null) => {

      if (user) {
        setState((prev) => ({ ...prev, user: user }));
        const token = await user.getIdToken();
        console.log('my token: ', token);
        const uInfo = (await axios.get(`${process.env.NEXT_PUBLIC_USER_SERVICE_API_BASE || process.env.REACT_APP_USER_SERVICE_API_BASE}/users`, { headers: { 'Authorization': `Bearer ${token}`} })).data;
        console.log('user-info', uInfo)
        // window.dispatchEvent(new CustomEvent('logged-in'));
        
        //@ts-ignore
        uInfo?.id && window?.gtag('event', 'G-ZE5MDXDKM8', {
          'user_id': `${uInfo?.id}`
        });
        
        uInfo?.id && sendGAEvent('event','userid_9', { value: `${uInfo?.id}` });
        // sendGAEvent({ event: 'userid_9', value: `123` });
        // sendGAEvent('event', 'userid_9',  { value: 'xyzz' });
        // sendGAEvent({ event: 'userid_9', user_id: `${uInfo?.id}` });
        // sendGAEvent('event', 'userid_9', { value: 'xyz' })
        
        // sendGTMEvent({'event': 'userid_9', value: 'xyz'})

        setUserInfo(uInfo);
      } else {
        setState({ ...state, user: null });
      }
    });
  }

  const isAuth = () => {
    return !!state.user;
  }

  const loginRequested = (reload?: boolean) => {
    console.log(reload);
    setLoginFor(undefined);
    // setIsReloadNeed(reload || false);
    isReloadNeedRef.current = reload || false;
    if (isMeMenuOpened) {
      setTimeout(() => {
        setLoginModalMode('login');
        setIsLoginModalOpened(true);
      }, 400);
      setIsMeMenuOpened(false);
    } else {
      setLoginModalMode('login');
      setIsLoginModalOpened(true);
      window.addEventListener('message', onLoginMessage);
    }
    
  }

  const registerRequested = () => {

    setLoginModalMode('register');
    setIsLoginModalOpened(true);
  }

  const handleLoginClosed = (isLoggedIn?: boolean) => {
    setIsLoginModalOpened(false);
  }

  const handleMeMenuRequested = () => {
    if (state.user) {
      setIsBuyerModalOpen(true);
    } else {
      isReloadNeedRef.current = true;
      window.addEventListener('message', onLoginMessage);
      setIsMeMenuOpened(true);
    }
  }

  const handleSearchClicked = () => {
    props.onMobileSearchClicked?.();
  }

  const onLoginMessage = async (msgEvent: MessageEvent) => {
    const { source, type, data } = msgEvent.data;
    if (source !== 'login' || (type !== 'logged-in' && type !== 'registered')) {
      return;
    }
    console.log(loginForRef.current);
    console.log('app bar >>>> logged');
    window.dispatchEvent(new CustomEvent(type, { detail: { token: data.token, user: data.user } }));
    console.log(data)
    setState((prev) => ({ ...prev, userInfo: data.user }));
    // setUserInfo(data);
    props.auth.currentUser && await props.auth.currentUser?.reload();
    console.log(`reload: ${isReloadNeedRef.current}`);

    window.removeEventListener('message', onLoginMessage);

    if (isMobile) {
      setPath(loginForRef.current || null);
      isReloadNeedRef.current && window.location.reload();
      // setIsBuyerModalOpen(true);
    } else {
      isReloadNeedRef.current && window.location.reload();
      // window.location.href = `${process.env.NEXT_PUBLIC_BUYER_URL}${loginForRef.current || ''}`
    }
    
  }

  const handleBuyerMenuClicked = (type: string, link?: string) => {
    const logged = isAuth();
    if (logged) {
      setPath(null);
      if (isMobile) {
        setIsBuyerModalOpen(true);
      } else {
        window.location.href = `${process.env.NEXT_PUBLIC_BUYER_URL}${link || ''}`
      }
      
    } else {
      setIsMeMenuOpened(false);

      setLoginModalMode('login');
      setIsLoginModalOpened(true);
      
      setLoginFor(link);
      window.addEventListener('message', onLoginMessage);
    }
  }

  const handleProfileMenuClicked = (type: string, link?: string) => {
    switch (type) {
      case 'login':
        loginRequested(true);
        break;
      case 'register':
        registerRequested();
        break;
      case 'logout':
        window.location.href = `${process.env.NEXT_PUBLIC_LOGIN_URL_BASE}/logout`
        break;
      case 'appointment':
      case 'requirements':
      case 'interested':
      case 'recently':
      case 'inquiry':
        handleBuyerMenuClicked(type, link);
        break;
      case 'seller':
        window.location.href = `${process.env.NEXT_PUBLIC_SELLER_URL}`
        break;
      case 'company-profile':
      case 'affiliate-agent':
      case 'listing':
        if (link) {
          window.location.href = `${process.env.NEXT_PUBLIC_SELLER_URL}${link}`
        }
        break;
      case 'project':
      case 'sell':
      case 'rent':
      case 'article':
      case 'mortgage':
      case 'mortgageOrRedemption':
      case 'lease':
        props.onMenuClicked?.(type);
        break;
      default:
        break;
    }
  }

  const handleRequirementClicked = () => {
    props.onRequirementClicked?.(true);
  }

  const handelBottomMenuClicked = (key: string, option?: { reload?: boolean }) => {
    if (key === 'call' && (props.context?.seller || props.context?.data?.mobile)) {
      const callElement = document.createElement('a');
      callElement.href = `tel:${props.context.seller?.mobile || props.context?.data?.mobile}`;
      callElement.target = '_blank';
      callElement.click();
    }
    // else if (key === 'appointment') {
    //   const imageUrl = props.context.isProject ? 
    //     (props.context.data?.images?.length > 0 && props.context.data?.project_ID ? 
    //     getProjectImageUrl(props.context.data?.project_ID, props.context.data?.images[0].gallery_Images).full : '') :
    //     (props.context.data?.images?.length > 0 && props.context.data?.property_ID ? 
    //       getImageUrl(props.context.data?.property_ID, props.context.data?.images[0].gallery_Images).full : '');

    //   const name = (props.context.isProject ? props.context.data?.project_Name_TH : props.context.data?.property_Name) || '';
    //   setAppointmentState({
    //     imageUrl: imageUrl,
    //     name: name,
    //     type: props.context.isProject ? 'project' : 'property',
    //     id:  props.context.isProject ? props.context.data?.project_ID : props.context.data?.property_ID
    //   });
    //   setAppointmentDialog(true);
    // }
    else if (key === 'navigate') {
      if (props.context.data) {
        const data = props.context.data;
        const callElement = document.createElement('a');
        callElement.href = `https://www.google.com/maps/search/?api=1&query=${encodeURI(`${data.project_Latitude},${data.project_Longitude}`)}`;
        callElement.target = '_blank';
        callElement.click();
      }
    }

    if (option?.reload === true) {
      window.location.reload();
    }
  }

  const renderBottomBar = () => {
    if (isMobile) {
      switch (pathname) {
        case '/[...action]':
          if (props.context && !props.context.isList) {
            return (<ActivitiesBottomBar
              onMeRequested={handleMeMenuRequested}
              onRequirementClicked={handleRequirementClicked}
              onMenuClicked={handelBottomMenuClicked}
            />);
          }
        case '/':
        default:
          return (<ButtomMenuBar onMeRequest={handleMeMenuRequested} onRequirementClick={handleRequirementClicked} />);
      }
    } else {
      return (<></>);
    }
  }

  const handleAvatarClicked = () => {
    setIsMeMenuOpened(true);
  }

  return (
<ThemeProvider theme={natheme}>
    <AppBar 
      position="fixed" 
      color={'inherit'} 
      style={{ 
        zIndex: 999,
        backgroundColor: scrolled ? 'white' : 'transparent',
        boxShadow: scrolled ? '0px 2px 4px rgba(0, 0, 0, 0.1)' : 'none',
        display: isDesktop && scrolled ? 'none' : 'block',
        transition: 'background-color 0.3s ease'
      }}
    >
      <Box 
        sx={{ 
          maxWidth: '1496px', 
          margin: '0 auto', 
          width: '100%' 
        }}
      >
        { 
          isDesktop ? 
          <DesktopToolbar
            namespace="common"
            logoPath={props.logoPath}
            user={state.user}
            userInfo={state.userInfo || userInfo}
            menuItems={{
              auth: loggedMenuItems,
              nonauth: loggedMenuItems,
            }}
            onProfileMenuClick={handleProfileMenuClicked}
            onLanguageChanged={props.onLanguageChanged}
          />: 
          <MobileToolbar
            namespace="common"
            logoPath={props.logoPath}
            user={state.user}
            userInfo={state.userInfo || userInfo}
          
            onMenuItemClicked={handleProfileMenuClicked}
            onLanguageChanged={props.onLanguageChanged}
            onSearchClicked={handleSearchClicked}
            onAvatarClicked={handleAvatarClicked}
          />
        }
      </Box>
    </AppBar>
    { renderBottomBar() }
    <BuyerModal
      open={isBuyerModalOpen}
      path={path}
      onClose={() => { 
        setIsBuyerModalOpen(false);
        setPath(null);
      }}
      onLogoutRequested={() => { 
        setIsBuyerModalOpen(false);
        setPath(null);
        window.location.href = `${process.env.NEXT_PUBLIC_LOGIN_URL_BASE}/logout`
      }}
    />
    <LoginModal open={isLoginModalOpened} mode={loginModalMode} onLoginClosed={handleLoginClosed} />
    <MeMenu
      user={state.user}
      userInfo={state.userInfo}
      open={isMeMenuOpened}
      logo={props.logoPath}
      items={loggedMenuItems}
      additionalActions={
        <Box>
          <Button
            variant="text"
            sx={{ pr: 5, textTransform: 'none', fontWeight: '600' }}
            onClick={() => window.location.href = `${process.env.NEXT_PUBLIC_SELLER_URL}` }
          >
            { t('menu.sellerCenter') }
          </Button>
        </Box>
      }
      onClose={() => setIsMeMenuOpened(false)}
      onMenuClicked={handleProfileMenuClicked}
    />
    {/* { appointmentState &&
      <AppointmentDialog
        imageUrl={appointmentState.imageUrl}
        name={appointmentState.name}
        type={appointmentState.type}
        id={appointmentState.id}
        open={appointmentDialog}
        onClosed={() => setAppointmentDialog(false)}
      />
    } */}
  </ThemeProvider>
  );
}